<template>
  <div class="files-edit">
    <div class="files-edit__head">
      <div class="files-edit__dropzone_wrap">
        <BasePreloader v-if="pendingUpload"/>
        <label ref="dropzone"
               :class="dragoverMixin ? '_dragover' : null"
               class="files-edit__dropzone">
          <input v-if="!pendingUpload"
                 type="file"
                 multiple
                 @input="onFilesInputMixin">
          <span :style="{opacity: pendingUpload ? 0 : null}" class="files-edit__dropzone-btn">
            <BaseSvg name="ico-plus"/>
            <span>{{$tNewVacancy('Add')}}</span>
          </span>
        </label>
      </div>
    </div>

    <div v-if="filesToUpload.length && !vacancyId" class="files-edit__list-wrap">
      <h4 class="files-edit__list-title">{{$tNewVacancy('Awaiting download')}}:</h4>
      <div class="files-edit__list">
        <div v-for="(file, index) in filesToUpload"
             :key="index"
             class="files-edit__file">
          <div class="files-edit__file-label">{{file.name}}</div>
          <div class="files-edit__file-info">
            <span>{{getExtFromNameMixin(file.name)}},</span> {{file.size | formatSize}}
          </div>
          <button type="button"
                  @click.prevent="deleteFileToUpload(index)"
                  class="files-edit__btn-remove reset-button"
          >
            <BaseSvg name="ico-close"/>
          </button>
        </div>
      </div>
    </div>

    <div v-if="filesUploaded.length" class="files-edit__list-wrap">
      <h4 class="files-edit__list-title">{{$tNewVacancy('Already uploaded')}}:</h4>
      <div class="files-edit__list">
        <div v-for="(file, index) in filesUploaded"
             :key="file.id"
             class="files-edit__file">
          <div class="files-edit__file-label">{{file.name}}</div>
          <div class="files-edit__file-info">
            <span>{{file.ext}},</span> {{file.size | formatSize}}
          </div>
          <div v-if="file.deletePending"
               class="files-edit__btn-remove reset-button">
            <BasePreloader/>
          </div>
          <button v-else
                  type="button"
                  @click="deleteFileUploaded(index, file.id)"
                  class="files-edit__btn-remove reset-button">
            <BaseSvg name="ico-close"/>
          </button>
        </div>
      </div>
    </div>

    <BaseAlert :value="errorMixin"
               class="files-edit__inline-alert  _error"/>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import fileUploadMixin from '../mixins/fileUploadMixin'

  export default {
    name: "FilesEdit",
    mixins: [fileUploadMixin],
    components: {},
    data() {
      return {
        dragoverMixin: false,
        errorMixin: null,
        uploadFileMethodNameMixin: ['uploadFile'],
      }
    },
    computed: {
      ...mapState('vacancyEdit/files', [
        'muted',
        'pendingUpload',
        'filesToUpload',
        'filesUploaded',
      ]),
      vacancyId() {
        return this.$route.params.vacancyId
      }
    },
    methods: {
      uploadFile(files) {
        this.$store.commit('vacancyEdit/files/addFilesToUpload', files)
        if (this.$route.params.vacancyId) {
          this.$store.dispatch('vacancyEdit/files/upload', this.$route.params.vacancyId)
        }
      },
      deleteFileToUpload(index) {
        this.$store.commit('vacancyEdit/files/deleteFileToUpload', index)
      },
      deleteFileUploaded(index, id) {
        if (!this.vacancyId) return
        this.$store.dispatch('vacancyEdit/files/deleteFileUploaded', {
          vacancyId: this.vacancyId,
          index,
          id
        })
      }
    }
  }
</script>

<style>

</style>
